const rateLimits = [
  {
    rateLimitType: 'REQUEST_WEIGHT',
    interval: 'MINUTE',
    intervalNum: 1,
    limit: 1200
  },
  {
    rateLimitType: 'ORDERS',
    interval: 'SECOND',
    intervalNum: 10,
    limit: 50
  },
  {
    rateLimitType: 'ORDERS',
    interval: 'DAY',
    intervalNum: 1,
    limit: 160000
  },
  {
    rateLimitType: 'RAW_REQUESTS',
    interval: 'MINUTE',
    intervalNum: 5,
    limit: 6100
  }
]

export const rateLimitsByHeader = {
  'x-mbx-order-count-10s': 50,
  'x-mbx-order-count-1d': 160000,
  'x-mbx-used-weight': 6100,
  'x-mbx-used-weight-1m': 1200
}
export const rateLimitsTime = {
  'x-mbx-order-count-10s': 10000,
  'x-mbx-order-count-1d': 86400000,
  'x-mbx-used-weight': 30000,
  'x-mbx-used-weight-1m': 60000
}

